export default "__VITE_ASSET__D0xiqe40__"